import styled from 'styled-components';

export const Container = styled.div`
  h1 {
    color: ${(props) => props.theme.$steel_blue};
    font-size: 24px;
    font-weight: 700;
  }

  p {
    color: ${(props) => props.theme.$steel_blue};
    font-size: 14px;
  }

  img {
    width: 26px;
    height: 24px;
    aspect-ratio: 13/12;
  }
`;

export const SummaryGrid = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;

  .summary-row {
    display: flex;
    flex: 1;
    gap: 12px;
  }
`;
